import styled from "styled-components";
import NavItem from "../../default-styles/NavItem/NavItem.style.js";
import { StyleNavItemProps } from "./NavItem.types.js";

export const StyledNavItem = styled(NavItem)<StyleNavItemProps>`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: ${({ theme }) => `${theme.spacing[8]}`} 0;
    filter: ${({ disabled }) => (disabled ? "grayscale(1)" : undefined)};
    display: flex;
    align-items: center;
    gap: ${({ theme }) => `${theme.spacing[16]}`};
`;
